import { Button, Col, Input, Row, Select } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { debounce } from "lodash";

const { Option } = Select;

export function UserFilter({ filter, onFilterChange }) {
  const handleSearch = debounce((key, value) => {
    const newFilter = { ...filter, [key]: value };
    onFilterChange(newFilter);
  }, 300);

  const handleClear = () => {
    onFilterChange({ page: 1, limit: 10 });
  };

  return (
    <Row gutter={16}>
      <Col span={6}>
        <Input
          placeholder="Tìm kiếm ..."
          onChange={(e) => handleSearch("search", e.target.value)}
          prefix={<SearchOutlined />}
          size="large"
        />
      </Col>

      <Col span={6}>
        <Select
          placeholder="Chọn vai trò"
          value={filter.role || ""}
          onChange={(value) => handleSearch("role", value)}
          style={{ width: "100%" }}
          allowClear
          size="large"
        >
          <Option value="">Tất cả</Option>
          <Option value="staff">Trợ lý</Option>
          <Option value="user">Thành Viên</Option>
        </Select>
      </Col>

      <Col span={6}>
        <Select
          placeholder="Trạng thái xác thực"
          value={filter.isVerified || ""}
          onChange={(value) => handleSearch("isVerified", value)}
          style={{ width: "100%" }}
          allowClear
          size="large"
        >
          <Option value="">Tất cả</Option>
          <Option value="true">Đã xác thực</Option>
          <Option value="false">Chưa xác thực</Option>
        </Select>
      </Col>

      <Col span={6}>
        <Button icon={<ClearOutlined />} onClick={handleClear} size="large">
          Xóa bộ lọc
        </Button>
      </Col>
    </Row>
  );
}
